import { getJobCodeData } from "./employeeConfigUtils";

export const buildPubSLS3Data = async (
  createdAt,
  workgroup,
  seniorityListType,
  station,
  pubSLComments,
  userSession,
  seniorityList
) => {
  const publishedByWorkgroup = getJobCodeData(userSession.jobCode).workgroup;

  let pubSLS3Data = {
    createdAt: createdAt,
    workgroup: workgroup,
    seniorityListType: seniorityListType,
    station: station,
    metadata: {
      comments: pubSLComments,
      publishedByEid: userSession.eid,
      publishedByFirstName: userSession.firstName,
      publishedByLastName: userSession.lastName,
      publishedByWorkgroup: publishedByWorkgroup,
    },
    employees: seniorityList,
  };
  return pubSLS3Data;
};
